<div class="card portfolio-return-bar-chart h-100">
  <div class="card-body">
    @if (title || isPortfolioPerformance) {
      <div class="card-head">
        <div class="card-title">{{ title }}</div>
        @if (isPortfolioPerformance) {
          <div class="card-tools">
            <div class="seg">
              <button
                type="button"
                [class.active]="chartType === 'return'"
                (click)="chartType = 'return'; changeData()"
              >
                Return
              </button>
              <button
                type="button"
                [class.active]="chartType === 'volatility'"
                (click)="chartType = 'volatility'; changeData()"
              >
                Volatility
              </button>
            </div>
          </div>
        }
      </div>
    }
    <highcharts-chart
      [options]="chartOptions"
      style="width: 100%; height: auto; display: block"
    ></highcharts-chart>
  </div>
</div>
